"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSRDataUtilities = void 0;

var constant_1 = require("../config/constant");

var SSRDataUtilities =
/** @class */
function () {
  function SSRDataUtilities() {}

  SSRDataUtilities.processSingleSSRData = function (ssrData, ssrDataJson, ssrTknName) {
    // console.log("ssrData",ssrData);
    // console.log("ssrDataJson",ssrDataJson);
    // console.log("token",ssrTknName);
    if (!ssrData || !ssrDataJson || !ssrTknName) return;
    var source = this.findSRRSource(ssrDataJson, ssrTknName);
    if (!source) return;
    var ssr = ssrData.ssr_data.find(function (ssr) {
      return ssr.source === source;
    });
    if (!ssr) return; //let algorithmUsed = "ALGO_ONE";

    var algorithmUsed = this.identifyAlgorithm(ssr.ssrgroup, ssrDataJson);

    if (!constant_1.ALGORITHMS[algorithmUsed]) {
      return;
    }

    var algo = __spreadArrays(constant_1.ALGORITHMS[algorithmUsed]);

    var reversedAlgo = this.reverseArray(algo);

    if (!reversedAlgo) {
      return;
    }

    var decryptedSSRData = this.executeAlgorithm(reversedAlgo, ssr.ssrlist);

    if (!decryptedSSRData) {
      return;
    }

    return decryptedSSRData;
  };

  SSRDataUtilities.findSRRSource = function (ssrDataJson, ssrTknName) {
    var apiSource = ssrDataJson.api_data.find(function (api) {
      return api.source === ssrTknName;
    });
    if (!apiSource) return;
    return apiSource.id;
  };
  /**
   *
   * @param algorithmAlias
   *
   * Will identify the algorithm to be used based
   * on the alias given by the api response
   */


  SSRDataUtilities.identifyAlgorithm = function (algorithmAlias, ssrDataJson) {
    if (!algorithmAlias) {
      return "";
    }

    if (!ssrDataJson) {
      return "";
    }

    if (!ssrDataJson.synonyms) {
      return "";
    }

    var algoSynonyms = ssrDataJson.synonyms;
    var algorithmUsed = "";

    for (var _i = 0, algoSynonyms_1 = algoSynonyms; _i < algoSynonyms_1.length; _i++) {
      var synonym = algoSynonyms_1[_i];

      if (!synonym) {
        continue;
      }

      var synonymAlgo = synonym.value.find(function (algo) {
        return algo === algorithmAlias;
      });

      if (!synonymAlgo) {
        continue;
      }

      algorithmUsed = synonym.name;
      return algorithmUsed;
    }

    return "";
  };

  SSRDataUtilities.decode64 = function (input) {
    var keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv" + "wxyz0123456789+/" + "=";
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0; // remove all characters that are not A-Z, a-z, 0-9, +, /, or =

    var base64test = /[^A-Za-z0-9\+\/\=]/g;

    if (base64test.exec(input)) {
      alert("There were invalid base64 characters in the input text.\n" + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" + "Expect errors in decoding.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "$$$");

    do {
      enc1 = keyStr.indexOf(input.charAt(i++));
      enc2 = keyStr.indexOf(input.charAt(i++));
      enc3 = keyStr.indexOf(input.charAt(i++));
      enc4 = keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }

      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return unescape(output);
  };
  /**
   *
   * @param ssrlist
   *
   * Will return the reversed version of the array
   */


  SSRDataUtilities.reverseArray = function (ssrlist) {
    if (!ssrlist) {
      return [];
    }

    var reversedArray = ssrlist.slice().reverse();
    return reversedArray;
  };
  /**
   *
   * @param ssrlist
   *
   * Will concatenate all the array elements
   */


  SSRDataUtilities.concatArrayElements = function (ssrlist) {
    if (!ssrlist) {
      return "";
    }

    var concatenatedArray = ssrlist.join('');
    return concatenatedArray;
  };
  /**
   *
   * @param ssrlist
   *
   * Will remove one extra character from each of the array elements
   */


  SSRDataUtilities.removeExtraChar = function (ssrlist) {
    if (!ssrlist) {
      return [];
    }

    var removedExtraCharSSRList = [];
    ssrlist.forEach(function (ssr) {
      if (!ssr) {
        return;
      }

      var removedCharSSR = ssr.substring(0, ssr.length - 1);
      removedExtraCharSSRList.push(removedCharSSR);
    });
    return removedExtraCharSSRList;
  };
  /**
   *
   * @param ssrlist
   * @param xPlace
   *
   * Will only include items that are not in multiples of xPlace
   */


  SSRDataUtilities.removeRandomStringAtXPlace = function (ssrlist, xPlace) {
    if (!ssrlist) {
      return;
    }

    var removedExtraFromSSRList = [];

    for (var i = 0; i < ssrlist.length; i++) {
      if ((i + 1) % xPlace !== 0) {
        removedExtraFromSSRList.push(ssrlist[i]);
      }
    }

    return removedExtraFromSSRList;
  };
  /**
   *
   * @param ssrlist
   * @param xPlace
   *
   * Will only include items that are in multiples of xPlace
   */


  SSRDataUtilities.removeRandomOnlyAtXPlace = function (ssrlist, xPlace) {
    if (!ssrlist) {
      return;
    }

    var removedExtraFromSSRList = [];

    for (var i = 0; i < ssrlist.length; i++) {
      if ((i + 1) % xPlace === 0) {
        removedExtraFromSSRList.push(ssrlist[i]);
      }
    }

    return removedExtraFromSSRList;
  };
  /* XOR DECRYPT  */


  SSRDataUtilities.a_one = function (value) {
    var decryptedStr = '';
    var xorKey = 'infalaysientgdia';
    var len = xorKey.length;
    var newValue = atob(value);

    for (var index = 0; index < newValue.length; index++) {
      decryptedStr += String.fromCharCode(newValue.charCodeAt(index) ^ xorKey.charCodeAt(index % len));
    }

    return decryptedStr;
  };

  SSRDataUtilities.reverseXChar = function (value, key) {
    var newValue = '';

    for (var index = 0; index < value.length; index = index + key) {
      newValue += value.substring(index, index + key).split('').reverse().join('');
    }

    return newValue;
  };
  /* Triple DES Algorithm */


  SSRDataUtilities.a_two = function (value) {
    var key = [10, 4, 15];
    var decryptedStr = this.reverseXChar(this.reverseXChar(this.reverseXChar(value, key[2]), key[1]), key[0]);
    return decryptedStr;
  };
  /* Rail fence Algo  */


  SSRDataUtilities.a_three = function (cipher, key) {
    var rail = new Array(key);

    for (var i = 0; i < key; i++) {
      rail[i] = new Array(cipher.length);
    } // filling the rail matrix to distinguish filled 
    // spaces from blank ones 


    for (var i = 0; i < key; i++) {
      for (var j = 0; j < cipher.length; j++) {
        rail[i][j] = '\n';
      }
    } // to find the direction 


    var dir_down;
    var row = 0,
        col = 0; // mark the places with '*' 

    for (var i = 0; i < cipher.length; i++) {
      // check the direction of flow 
      if (row == 0) dir_down = true;
      if (row == key - 1) dir_down = false; // place the marker 

      rail[row][col++] = '*'; // find the next row using direction flag 

      dir_down ? row++ : row--;
    } // now we can construct the fill the rail matrix 


    var index = 0;

    for (var i = 0; i < key; i++) {
      for (var j = 0; j < cipher.length; j++) {
        if (rail[i][j] == '*' && index < cipher.length) rail[i][j] = cipher[index++];
      }
    } // now read the matrix in zig-zag manner to construct 
    // the resultant text 


    var result = '';
    row = 0, col = 0;

    for (var i = 0; i < cipher.length; i++) {
      // check the direction of flow 
      if (row == 0) dir_down = true;
      if (row == key - 1) dir_down = false; // place the marker 

      if (rail[row][col] != '*') result = rail[row][col++] + result; // find the next row using direction flag 

      dir_down ? row++ : row--;
    }

    return result.split('').reverse().join('');
  };
  /* Coloumn Transposition Decryption */


  SSRDataUtilities.a_four = function (ciphertext, keyword) {
    var klen = keyword.length; // first we put the text into columns based on keyword length

    var cols = new Array(klen);
    var colLength = ciphertext.length / klen;

    for (var i_1 = 0; i_1 < klen; i_1++) {
      cols[i_1] = ciphertext.substr(i_1 * colLength, colLength);
    } // now we rearrange the columns so that they are in their unscrambled state


    var newcols = new Array(klen);
    var j = 0;
    var i = 0;
    var chars = "abcdefghijklmnopqrstuvwxyz";

    while (j < klen) {
      var t = keyword.indexOf(chars.charAt(i));

      if (t >= 0) {
        newcols[t] = cols[j++];
        var arrkw = keyword.split("");
        arrkw[t] = "_";
        keyword = arrkw.join("");
      } else i++;
    } // now read off the columns row-wise


    var plaintext = "";

    for (i = 0; i < colLength; i++) {
      for (j = 0; j < klen; j++) {
        plaintext += newcols[j].charAt(i);
      }
    }

    return plaintext.replace(/@/g, '');
  };
  /**
   *
   * @param algorithmOrder
   * @param ssrlist
   *
   * Will execute the functions indicated in the algorithm array sequentially
   */


  SSRDataUtilities.executeAlgorithm = function (algorithmOrder, ssrlist) {
    var _this = this;

    if (!algorithmOrder || !ssrlist) {
      return;
    }

    var newSSRValue = null;

    var start = function start(index, value) {
      switch (algorithmOrder[index]) {
        case constant_1.BASE64:
          newSSRValue = _this.decode64(value);
          break;

        case constant_1.REVERSE:
          newSSRValue = _this.reverseArray(value);
          break;

        case constant_1.ADD_EXTRA_CHAR:
          newSSRValue = _this.removeExtraChar(value);
          break;

        case constant_1.SPLIT_INTO_THREE:
        case constant_1.SPLIT_INTO_FOUR:
        case constant_1.SPLIT_INTO_FIVE:
          newSSRValue = _this.concatArrayElements(value);
          break;

        case constant_1.INSERT_RANDOM_AT_3:
          newSSRValue = _this.removeRandomStringAtXPlace(value, constant_1.ALGORITHM_INDEX);
          break;

        case constant_1.XOR_ENCRYPT:
          newSSRValue = _this.a_one(value);
          break;

        case constant_1.TRIPLEDES:
          newSSRValue = _this.a_two(value);
          break;

        case constant_1.RAIL_FENCE_CIPHER:
          newSSRValue = _this.a_three(value, 7);
          break;

        case constant_1.COL_TRANSPOSITION_ENCODE:
          newSSRValue = _this.a_four(value, "depart");
          break;

        default:
          break;
      }

      index++;

      if (algorithmOrder.length > index) {
        start(index, newSSRValue);
      }
    };

    start(0, ssrlist);
    return "" + newSSRValue;
  };

  return SSRDataUtilities;
}();

exports.SSRDataUtilities = SSRDataUtilities;